<!-- @format -->
<template>
    <div class="email-test-widget">
        <div class="widget-header">
            <h3>Send Test Email</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <div class="email-container">
                <div class="label-container">
                    <div class="title">Where would you like to send a test email?</div>
                </div>
                <app-input
                    v-model="emailAddress"
                    :isValid="$v.email.required"
                    :placeholder="'Email Address'"
                    :error="'This field is required'"
                    type="email"
                />
            </div>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget">Cancel</app-button>
            </div>
            <div class="action-container">
                <app-button @click="sendTest()">Send Test</app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const AppInput = () => import('@/components/common/app-input');

import EventBus from '@/scripts/event-bus.js';
import { required, email, number } from 'vuelidate/lib/validators';

export default {
    name: 'email-test-widget',

    components: {
        'app-input': AppInput,
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            emailAddress: null,
            campaignId: this.widget.campaignId,
            campaignTemplateId: this.widget.campaignTemplateId,
            templateId: this.widget.templateId,
            emailTemplateId: this.widget.emailTemplateId,
            journeyStepId: this.widget.journeyStepId,
            version: this.widget.version || 'A',
            clientContextId: this.widget.clientContextId,
        };
    },

    validations() {
        return {
            email: {
                required,
                email,
            },
        };
    },

    computed: {
        isValid() {
            if (!this.$v.$invalid) {
                return true;
            }
        },
    },

    methods: {
        sendTest() {
            return new Promise((resolve, reject) => {
                this.$v.$touch();

                if (this.emailAddress) {
                    var request = {
                        CampaignId: this.campaignId,
                        CampaignTemplateId: this.campaignTemplateId,
                        TemplateId: this.templateId,
                        EmailTemplateId: this.emailTemplateId,
                        JourneyStepId: this.journeyStepId,
                        ClientContextId: this.clientContextId,
                        Email: this.emailAddress,
                        Version: this.version,
                    };

                    this.$api
                        .post(`/api/Emails/Test`, request)
                        .then(() => {
                            this.$helpers.showSuccessNotification('Test successfully sent!');
                            this.closeWidget();
                            resolve();
                        })
                        .catch((error) => {
                            this.$helpers.showFailNotification(
                                'An error occurred while sending your test.',
                                { error },
                            );
                            reject();
                        });
                }
            });
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },
};
</script>

<style>
.email-test-widget .email-container {
    position: relative;
    border: 2px solid #e9e9ef;
    border-radius: 22px;
    margin-bottom: 45px;
    padding: 25px 25px 10px;
}

.email-test-widget .label-container {
    display: flex;
    align-items: center;
    margin: 0 auto;
    margin-left: -178px;
    position: absolute;
    top: -15px;
    background-color: #fff;
    font-weight: 600;
    justify-content: space-around;
    left: 50%;
    padding: 0 25px;
}
</style>
